import React, { type RefObject, useContext } from 'react';

import { Text } from '@atlaskit/primitives/compiled';

import { TeamInlinePreviewContext } from '../../store/context';

/**
 * Internal component that renders the team name text.
 * Supports single-line mode and accepts an optional ref for truncation detection.
 */
function TeamName({
	teamName,
	elementRef,
}: {
	teamName: string;
	elementRef?: RefObject<HTMLElement>;
}): React.JSX.Element {
	const { singleLine, getTestId } = useContext(TeamInlinePreviewContext);
	const maxLines = singleLine ? 1 : undefined;

	return (
		<Text size="medium" maxLines={maxLines} ref={elementRef} testId={getTestId('team-name')}>
			{teamName}
		</Text>
	);
}

export { TeamName };
